import { get, post } from './fetcher';

const STD_PRICE_ENDPOINTS = {
  SIDO: '/api/admin/std-prices/regions/sido',
  SIGUNGU: '/api/admin/std-prices/regions/sigungu',
  DONG: '/api/admin/std-prices/regions/dong',
  ROWS: '/api/admin/std-prices/rows',
  UPSERT: '/api/admin/std-prices',
};

// 시도 목록
export const getSido = async (token) => {
  const response = await get(STD_PRICE_ENDPOINTS.SIDO, {}, token);
  if (response?.success) return response.data || [];
  throw new Error(response?.message || '시도 조회에 실패했습니다.');
};

// 시군구 목록 (시도 코드 기준)
export const getSigungu = async (token, sidoCode) => {
  const response = await get(STD_PRICE_ENDPOINTS.SIGUNGU, { sidoCode }, token);
  if (response?.success) return response.data || [];
  throw new Error(response?.message || '시군구 조회에 실패했습니다.');
};

// 읍면동 목록 (시군구 코드 기준)
export const getDong = async (token, sigunguCode) => {
  const response = await get(STD_PRICE_ENDPOINTS.DONG, { sigunguCode }, token);
  if (response?.success) return response.data || [];
  throw new Error(response?.message || '읍면동 조회에 실패했습니다.');
};

// 기준가 목록 조회 (지역코드, 단지명, 페이징) → { items, total, page, pageSize }
export const getStdPriceRows = async (token, { bjdCode, danjiName, page = 1, pageSize = 50 } = {}) => {
  const params = { page, pageSize };
  if (bjdCode) params.bjdCode = bjdCode;
  if (danjiName) params.danjiName = danjiName;
  const response = await get(STD_PRICE_ENDPOINTS.ROWS, params, token);
  if (response?.success) {
    const data = response.data || {};
    return {
      items: data.items || [],
      total: data.total || 0,
      page: data.page || page,
      pageSize: data.pageSize || pageSize,
    };
  }
  throw new Error(response?.message || '기준가 조회에 실패했습니다.');
};

// 기준가 단건 upsert → { ok, message }
export const upsertStdPrice = async (token, row) => {
  const response = await post(STD_PRICE_ENDPOINTS.UPSERT, row, token);
  return { ok: !!response?.success, message: response?.message };
};
